/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DashboardAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AssignedToMe from './AssignedToMe/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2TasksHomeIcon from 'DesignSystem/Svgs/Tysiav2TasksHomeIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function DashboardAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/DashboardAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flow = fromFlow.useFlow()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
  return (<React.Fragment
>
<div
  data-testid="DashboardAction.Vertical"
  data-view-path={viewPath}
 style={{'--mr-1-108rNR': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-108rNR': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-108rNR': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="DashboardAction.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--btrr-5-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btlr-6-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-7-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-8-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bc-4-108rNR': flow.has(fromFlow.normalizePath(viewPath, '../../../Content/Home')) ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DashboardAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-4-108rNR': dtColorsGreen200,'--btlr-6-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-8-108rNR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical1}`}
>
<Tysiav2TasksHomeIcon
  viewPath={`${viewPath}/Tysiav2TasksHomeIcon`}
 iconHeight={18}
 iconWidth={18}
 fill2={dtColorsGreen900}
/>
</div>
<div
  data-testid="DashboardAction.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-2-108rNR': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Home"
/>
<AssignedToMe
  viewPath={`${viewPath}/AssignedToMe`}
/>
</div>
</button>
</div>
{children}
</React.Fragment>)
}